module.exports = __webpack_public_path__ + "images/blue_bg2-f8b264f2f9.png";